import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import Accordion from "../../../common/accordion";
import useJetliftCollapseFacade from "../../../../facade/jetlift/collapse/collapse.facade";
import useInputValidations from "../InputValidations";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import { LABELS } from "../../../../constants/labels/jetlift/jetlift.labels";

const Fluid: React.FC = () => {
    const { register, control } = useFormContext();
    const {
        getdefaultCollapse,
        handleCollapseChange,
    } = useJetliftCollapseFacade();
    const { sectionsData, renderField, fluidGasVolumeRenderFields } = useInputValidations();
    const [form, setForm] = useState<{ [key: string]: string }>({});
    const { fluidInput } = useAppSelector((state) => state?.jetlift?.fluid);

    const handleChange = (label: string, value: string) => {
        setForm((prev) => ({ ...prev, [label]: value }));
    };

    return (
        <div className="flex flex-col gap-[16px]">
            {sectionsData?.fluid?.map((section, secIdx) => {
                if (section?.section === LABELS?.gasVolume) {
                    return (
                        <div key={secIdx} className="flex flex-col">
                            {fluidGasVolumeRenderFields(
                                LABELS?.gasVolume,
                                form,
                                handleChange,
                                register,
                                control,
                                fluidInput
                            )}
                        </div>
                    );
                }

                if (section?.section === "") {
                    return null;
                }

                return section?.section !== ""
                    ? (
                        <div
                            key={secIdx}
                            className="flex flex-col"
                        >
                            <Accordion
                                title={section.section}
                                isOpen={getdefaultCollapse(section?.section) ?? false}
                                onToggle={() => handleCollapseChange(!getdefaultCollapse(section?.section), section?.section)}
                                content={
                                    <div className="flex flex-col gap-[16px] p-[12px]">
                                        {section.fields.map((field, idx) => {
                                            const dependencyValue = 'dependsOn' in field && field.dependsOn
                                                ? fluidInput?.[field.dependsOn as keyof typeof fluidInput]
                                                : undefined;
                                            return (
                                                (
                                                    <div key={idx}>
                                                        {
                                                            (!dependencyValue || dependencyValue === (field as any)?.visibleWhen) &&
                                                            renderField(field, form, handleChange, register, control)
                                                        }
                                                    </div>
                                                )
                                            )
                                        })}
                                    </div>
                                }
                            />
                        </div>
                    ) : (
                        <div className="flex flex-col gap-[16px]">
                            {section.fields.map((field, idx) => {
                                const dependencyValue = 'dependsOn' in field && field.dependsOn
                                    ? fluidInput?.[field.dependsOn as keyof typeof fluidInput]
                                    : undefined;
                                return (
                                    <div key={idx}>
                                        {
                                            (!dependencyValue || dependencyValue === (field as any)?.visibleWhen) &&
                                            renderField(field, form, handleChange, register, control)
                                        }
                                    </div>
                                )
                            }
                            )}
                        </div>
                    )
            })}
        </div>
    );
};

export default Fluid;
